import { ResourceCalculationBase } from './base/resource-calculation-base';

export class ResourceCalculation extends ResourceCalculationBase { }